import { FcuUnit } from './fcu-unit';
import { CommunicationType } from './fu-unit';
import { Port } from './port';

export class CeuUnit {
    id: string;
    index: number;
    fcuId: string;
    vesselId: string;
    Ports: Port[];
    commType: CommunicationType;
    lineAIp: string;
    lineBIp: string;
    location?: string;
    FcuUnit?: FcuUnit;
}

export const ceuMaxNum = 16;
